<section class="content">
  <div class="card">
    <div class="card-body-generate">
      <div class="highcharts-loading">
        <div class="highcharts-loading-inner"></div>
      </div>
      <h3>
        Please wait a moment while we're requesting your certificate...
      </h3>
      <div class="mt-5">
        <a routerLink="/audits" class="btn btn-light">Go back to reports list</a>
      </div>
    </div>
  </div>
</section>

